export default {"src":"/_next/static/media/tictok.32f3e329.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};